module.exports = __webpack_public_path__ + "img/1.760637b6.png";